export default __webpack_public_path__ + "static/chart-1b277cb2e4dcc58657cb43d76d3881f1.svg";